module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "rt-breadcrumb__item"
  }, [_c('span', {
    ref: "link",
    class: ['rt-breadcrumb__inner', _vm.to ? 'is-link' : ''],
    attrs: {
      "role": "link"
    },
    on: {
      "click": function($event) {
        return _vm.onItemClick()
      }
    }
  }, [(_vm.prevIconName) ? _c('rt-icon', {
    attrs: {
      "name": _vm.prevIconName,
      "size": "16"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "rt-breadcrumb__separator"
  }, [_c('rt-icon', {
    attrs: {
      "name": _vm.splitIconName
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fa42a26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/breadcrumb/rtBreadcrumbItem.vue
// module id = 2176
// module chunks = 137